const parseJsonSafe = (value: string): Record<string, any> => {
  try {
    return JSON.parse(value)
  } catch {
    return {}
  }
}

export default parseJsonSafe
